import type { ComponentProps } from 'react'
import CrawlResults from '@/app/(app)/tools/ai-crawl-checker/components/CrawlResults'
import type { ToolDetailProps } from './detailRegistry'

/**
 * Dashboard detail renderer for `crawl` (Phase 3, Step 10 — Class B,
 * dashboard-reuse). This REPLACES the legacy inline `crawl` branch that lived
 * in `ToolDetailPanel` (a thin bot-name/allowed/responseTime grid).
 *
 * REUSES the public `CrawlResults` with `variant="dashboard"`, which hides the
 * public-only chrome (the email-share row, PlatformCTA, and the gradient
 * services CTA). The platform route (`/api/platform/tools/crawl-check`) runs
 * the same lib and returns the same `CrawlCheckResult`, so the dashboard `data`
 * maps straight onto the component — the dashboard now shows the full rich
 * report (score ring, partial-scan banner, AI analysis, the full bot-access
 * grid with WAF/403 badges, the four category score cards with robots.txt /
 * structured-data / llms.txt score/5 / content-access detail, and
 * recommendations with their three blog links) instead of the generic panel.
 *
 * Wrapped in `id="tool-detail-panel"` so the dashboard scroll-to-panel still
 * works. Grade comes from `data.grade` via the reused component — never
 * recomputed; the category-score math stays inside the reused renderer (the
 * deleted generic `deriveBreakdown` is NOT reintroduced). Render-layer only.
 */
export function CrawlDashboardDetail({ data }: ToolDetailProps) {
  const result = data as unknown as ComponentProps<
    typeof CrawlResults
  >['result']
  return (
    <div
      id='tool-detail-panel'
      className='rounded-xl border border-border bg-card p-5'
    >
      <CrawlResults result={result} variant='dashboard' />
    </div>
  )
}
